<ng-container
  *ngIf="{
    config: moduleConfig$ | async,
    props: propsFromHost$ | async,
  } as config"
>
  <parcel
    *ngIf="config.config && config.props"
    data-federated-wrapper="scroll"
    [config]="config.config"
    [customProps]="config.props"
    [mountParcel]="mountParcel"
  ></parcel>
</ng-container>
